var exports = {
  "Nr": "x936d19a0--5db856--card",
  "aD": "x936d19a0--5db856--card_mobile",
  "hQ": "x936d19a0--5db856--card_icon",
  "I5": "x936d19a0--5db856--card_pic",
  "AI": "x936d19a0--5db856--checkmark",
};

module.exports = exports;
